export const getBleed = (size: number) => {
	const parsedNegativeSize = (-size).toString();
	const parsedSize = size.toString();

	return `
		margin: ${parsedNegativeSize}px;
		padding: ${parsedSize}px;
	`;
};
